import { CellContext } from '@tanstack/react-table';
import { TagsBubbles } from 'application/Shared/Components/Tag/TagLinksList';
import { TagLink } from 'application/Shared/types/tagLinks';

/* React */
import React from 'react';

interface RowData {
    tagLinks: TagLink[];
}

/**
 * Cell component that renders tag links as bubbles
 * @param {CellContext<TData, unknown>} props - Cell context from react-table
 * @returns {React.ReactElement} TagsBubbles component with tag links
 * @template TData - Type extending RowData interface
 */
export const TagLinksCell = <TData extends RowData>({
    cell
}: CellContext<TData, unknown>): React.ReactElement => (
    // @ts-expect-error component is not typed yet
    <TagsBubbles tagLinks={cell.getValue()} />
);
